import { PublicClientApplication } from '@azure/msal-browser';
import getConfig from 'config';

let singletonMsalInstance: PublicClientApplication | undefined;

export async function acquireAccessToken(
  msalInstance: PublicClientApplication = getMsalInstance(),
): Promise<string> {
  // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
  const activeAccount = msalInstance.getActiveAccount();
  if (!activeAccount) {
    /*
     * User is not signed in. Throw error or wait for user to login.
     * Do not attempt to log a user in outside of the context of MsalProvider
     */

    throw new Error('User is not signed in');
  }

  const scopes = getRequiredScopes();

  try {
    const authResult = await msalInstance.acquireTokenSilent({
      account: activeAccount,
      scopes,
    });
    return authResult.accessToken;
  } catch (error) {
    await msalInstance.loginRedirect({ scopes });
    throw error;
  }
}

export function forceLogout(msalInstance: PublicClientApplication = getMsalInstance()) {
  msalInstance
    .logoutRedirect({ account: msalInstance.getActiveAccount() })
    .catch((err) => console.log(err));
}

export function getLoggedInUser(
  msalInstance: PublicClientApplication = getMsalInstance(),
) {
  const activeAccount = msalInstance.getActiveAccount();

  if (!activeAccount) return undefined;

  const igg = activeAccount?.idTokenClaims?.employeeid as string | undefined;
  const givenName = activeAccount?.idTokenClaims?.given_name as string | undefined;
  const familyName = activeAccount?.idTokenClaims?.family_name as string | undefined;
  const roles = activeAccount?.idTokenClaims?.roles as string[] | undefined;
  const oid = activeAccount?.idTokenClaims?.oid as string | undefined;
  if (!igg || !givenName || !familyName || !roles || !oid) {
    return undefined;
  }
  return { familyName, givenName, igg, oid, roles };
}

export function getMsalInstance() {
  if (!singletonMsalInstance) {
    const config = getConfig();
    singletonMsalInstance = new PublicClientApplication({
      auth: {
        authority: config.entraAuthority,
        clientId: config.entraClientId,
        redirectUri: config.entraRedirectUri,
      },
    });
  }
  return singletonMsalInstance;
}

export function getRequiredScopes() {
  return getConfig().entraScopes;
}

export function isLoggedIn(msalInstance: PublicClientApplication = getMsalInstance()) {
  return !!getLoggedInUser(msalInstance);
}
